<template>
    <div class="card not-word-wrap mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row m-0 mb-4">
                <div  v-if="referenceNumber" class="col-4 px-2 py-1 border-0">
                    <div class="table-responsive">
                        <table class="table main-table-reference text-nowrap my-0">
                            <tbody>
                                <tr>
                                    <td class="bg-gray-200"><b>
                                                شماره رفرنس </b></td>
                                    <td style="display: flex; flex-direction: row; align-items: center;" > 
                                        <b>
                                            {{ referenceNumber || "-" }}
                                        </b>
                                            <button class="btn btn-icon mx-2" v-on:click="copyToClipBoard(referenceNumber)" >
                                                    <i class="ti-files "> </i>  
                                            </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div v-if="trackingCode" class="col-8 px-2 py-1 border-0">
                    <div class="table-responsive">
                        <table class="table main-table-reference text-nowrap my-0">
                            <tbody>
                                <tr>
                                    <td class="bg-gray-200" width="40%"><b>
                                            کد پیگیری</b></td>
                                    <td style="display: flex; flex-direction: row; align-items: center;" > 
                                        <b>
                                            {{ trackingCode || "-" }}
                                        </b>
                                            <button  class="btn btn-icon mx-2" v-on:click="copyToClipBoard(trackingCode)" >
                                                <i class="ti-files "> </i>  
                                            </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">

                    <form v-on:submit.prevent="submit">
                        <div class="row">

                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>
                                        <label style="color: red; height: 2px;" >*</label>
                                        نام
                                    </label>
                                    <input required class="form-control" v-model="name">
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>
                                         <label style="color: red; height: 2px;" >*</label>
                                        نام خانوادگی </label>
                                    <input required class="form-control" v-model="lastName">
                                </div>
                            </div>

                            <div class="col-md-3">
                                <label>
                                     <label style="color: red; height: 2px;" >*</label>
                                     جنسیت </label>
                                <select required class="form-control" v-model="gendersId">
                                    <option :value="gender.value" v-for="(gender, index) in genders" :key="index">{{
                                        gender.title }}</option>
                                </select>
                            </div>

                            <div class="col-md-3">
                                <label> وضعیت تاهل </label>
                                <select class="form-control" v-model="maritalStatusesId">
                                    <option :value="maritalStatus.value" v-for="(maritalStatus, index) in maritalStatuses"
                                        :key="index">{{ maritalStatus.title }}</option>
                                </select>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>
                                        نام مادر
                                    </label>
                                    <input class="form-control" v-model="motherName">
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>  <label style="color: red; height: 2px;" >*</label>
                                        نام پدر </label>
                                    <input required class="form-control" v-model="fatherName">
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group">
                                    <label> اجداد </label>
                                    <input class="form-control" v-model="ancestorName">
                                </div>
                            </div>

                            <div class="col-md-3">
                                <label>  <label style="color: red; height: 2px;" >*</label>
                                    ملیت </label>
                                <select required class="form-control" v-model="nationalitiesId">
                                    <option :value="national.value" v-for="(national, index) in nationalities" :key="index">
                                        {{ national.title }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <label> <label style="color: red; height: 2px;" >*</label>
                                     کشور محل تولد </label>
                                <select required class="form-control" v-model="birthPlaceCountriesId">
                                    <option :value="country.value" v-for="(country, index) in birthPlaceCountries"
                                        :key="index">{{ country.title }}</option>
                                </select>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>
                                         <label style="color: red; height: 2px;" >*</label> شهر محل تولد </label>
                                    <input required class="form-control" v-model="cityOfBirth">
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>تاریخ تولد</label>
                                    <Datepicker simple auto-submit id="birthDate" locale="en" format="YYYY-MM-DD" input-format="YYYY/MM/DD" 
                                        v-model="birthDate" :max="today" :locale-config="{
                                        en: {
                                            displayFormat: 'YYYY/MM/DD'
                                        }
                                    }" />
                                </div>
                            </div>

                             <div class="col-md-3">
                                <label>شماره کارت</label>
                                <input class="form-control ltr-input" v-model="pan" v-mask="'####-####-####-####'">
                            </div>
                               
                        </div>
                        
                          <div class="row">
                             <div class="col-3 form-group">
                                <label>شماره همراه</label>
                                <input type="tel" class="form-control" v-model="mobileNumber" v-mask="'09##-#######'">
                            </div>
                             <div class="col-md-3">
                                    <label> <label style="color: red; height: 2px;" >*</label>
                                        تصویر پرسنلی</label>
                                    <div class="form-group">
                                        <div  class="input-group file-browser">
                                            <input type="text" class="form-control border-left-0 browse-file" id="file"
                                                placeholder="انتخاب کنید" readonly="">
                                            <label class="input-group-btn mb-0">
                                                <span class="btn btn-primary">
                                                    انتخاب کردن <input type="file" style="display: none" @change="setFileData"
                                                        accept="image/jpeg">
                                                </span>
                                            </label>
                                            <button v-if="image || photoBase64" class="btn btn-outline" @click="e => downloadBase64File(e ,image , photoBase64)" >
                                                <i class="ti-download m-1 "> </i> 
                                            </button>
                                        </div>
                                    </div>
                                </div>

                             <div class="col-md-6">
                                <div class="form-group">
                                    <label> توضیحات </label>
                                    <input class="form-control" v-model="description">
                                </div>
                            </div>
                          </div>

                             <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>
                                             <label style="color: red; height: 2px;" >*</label> شماره پاسپورت </label>
                                        <input required class="form-control" simple auto-submit v-model="identificationNumber"/>
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label><label style="color: red; height: 2px;" >*</label> 
                                            تاریخ صدور پاسپورت</label>
                                        <Datepicker simple auto-submit id="identificationIssueDate" locale="en" format="YYYY/MM/DD"  input-format="YYYY/MM/DD"
                                            v-model="identificationIssueDate" :max="today" :locale-config="{
                                            en: {
                                                displayFormat: 'YYYY/MM/DD',
                                            }
                                        }" />
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label><label style="color: red; height: 2px;" >*</label> 
                                            تاریخ انقضا پاسپورت</label>
                                         <Datepicker simple auto-submit id="identificationExpirationDate" locale="en" format="YYYY/MM/DD" input-format="YYYY/MM/DD"
                                            v-model="identificationExpirationDate" :locale-config="{
                                            en: {
                                                displayFormat: 'YYYY/MM/DD',
                                            }
                                        }" />
                                    </div>
                                </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div  style="
                                    padding:10px 22px 20px !important;
                                    border: 2px solid #e8e8f7;
                                    background: #f1f2f9;
                                    border-radius: 5px;">
                                        <div class="row d-flex align-items-center">
                                            <div class="col-6" v-for="(row, index) in identificationPhotos" :key="index">
                                                <label>تصویر پاسپورت  {{ index + 1 }}</label>
                                                <div class="form-group d-flex">
                                                    <div class="input-group file-browser">
                                                        <input type="text" class="form-control border-left-0 browse-file"
                                                            :id="'passport-' +  index" placeholder="انتخاب کنید" readonly="">
                                                        <label class="input-group-btn mb-0">
                                                            <span class="btn btn-primary">
                                                                انتخاب کردن <input type="file" style="display: none" :id=" 'passport-' +  index"
                                                                    @change="setfilename($event, 'passport-', index ,0)" accept="image/png, image/jpeg">
                                                            </span>
                                                        </label>
                                                        <button v-if="(typeof(row)=='object' && typeof(row.file) =='string' ) | typeof(row)=='string' " class="btn btn-outline" @click="e => downloadFile(e,row)" >
                                                            <i class="ti-download m-1 "> </i> 
                                                        </button>
                                                    </div>
                                                    <a v-on:click="removeelementPassWord(index );" v-if="index !== 0"
                                                        class="btn btn-danger px-3 py-2 mr-1" style="cursor: pointer"><i
                                                            class="ti-close text-white"></i></a>
                                                </div>
                                            </div>
                                            <div class="col-6 mt-2" v-if="identificationPhotos.length < 1">
                                                <a  class="btn btn-outline-primary px-3 py-2" style="cursor: pointer"  @click="addrowPassword()">
                                                    <i class="ti-plus"></i>
                                                     اضافه کردن عکس پاسپورت 
                                                </a>
                                            </div>
                                        </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-md-6 mb-4">
                                <label> نوع سند شناسایی </label>
                                <Vselect v-model="domainId" multiple :reduce="item => item.value" label="title" :options="identificationDocumentTypes">
                                    <div slot="no-options">مقداری یافت نشد</div>
                                </Vselect>
                            </div>
                        </div>

                        <div  v-if="documnentsList.length > 0 ">
                            <div class="row mt-2"  v-for="(documnet, docIndex) in documnentsList" :key="docIndex">
                                <div class="col-md-12">
                                    <div  style="
                                        padding:10px 22px 20px !important;
                                        border: 2px solid #e8e8f7;
                                        background: #f1f2f9;
                                        border-radius: 5px;">
                                        <div class="row d-flex align-items-center">
                                            <div class="col-12">
                                             <div class="row">
                                                <div class="col-4">
                                                    <div class="form-group">
                                                        <label> شماره {{ documnet.title }} </label>
                                                        <input class="form-control" simple auto-submit v-model="documnet.number"/>
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                    <div class="form-group">
                                                        <label>تاریخ صدور  {{ documnet.title }}</label>
                                                         <Datepicker simple :max="today" auto-submit id="documnet.issueDate" locale="en" format="YYYY/MM/DD" input-format="YYYY/MM/DD" 
                                                                v-model="documnet.issueDate" :locale-config="{
                                                                en: {
                                                                    displayFormat: 'YYYY/MM/DD',
                                                                }
                                                            }" />
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                    <div class="form-group">
                                                        <label>تاریخ انقضا  {{ documnet.title }}</label>
                                                        <Datepicker simple auto-submit id="documnet.expirationDate" locale="en" format="YYYY/MM/DD" input-format="YYYY/MM/DD" 
                                                            v-model="documnet.expirationDate" :locale-config="{
                                                            en: {
                                                                displayFormat: 'YYYY/MM/DD',
                                                            }
                                                        }" />
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                            <div class="col-6" v-for="(row, index) in documnet.photos" :key="index">
                                                <label>تصویر {{documnet.title }} {{ index + 1 }}</label>
                                                <div class="form-group d-flex">
                                                    <div class="input-group file-browser">
                                                        <input type="text" class="form-control border-left-0 browse-file"
                                                            :id="documnet.identificationDocumentTypeId + '-'+ index" placeholder="انتخاب کنید" readonly="">
                                                        <label class="input-group-btn mb-0">
                                                            <span class="btn btn-primary">
                                                                انتخاب کردن <input type="file" style="display: none" :id=" documnet.identificationDocumentTypeId + '-'+ index"
                                                                    @change="setfilename($event, documnet.identificationDocumentTypeId + '-', index ,docIndex)" accept="image/png, image/jpeg">
                                                            </span>
                                                        </label>
                                                        <button v-if="(typeof(row)=='object' && typeof(row.file) =='string' ) | typeof(row)=='string' " class="btn btn-outline" @click="e => downloadFile(e,row)" >
                                                            <i class="ti-download m-1 "> </i> 
                                                        </button>
                                                    </div>
                                                    <a v-on:click="removeelement(index,docIndex );" v-if="index !== 0"
                                                        class="btn btn-danger px-3 py-2 mr-1" style="cursor: pointer"><i
                                                            class="ti-close text-white"></i></a>
                                                </div>
                                            </div>
                                            <div class="col-6 mt-3" v-if="documnentsList[docIndex].photos.length < 1">
                                                <a  class="btn btn-outline-primary px-3 py-2 mt-3" style="cursor: pointer"  @click="addrow(docIndex)">
                                                    <i class="ti-plus">  </i>
                                                    اضافه کردن عکس {{ documnentsList[docIndex].title }}
                                                </a>
                                            </div>
                                        </div>
                                         
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class=" mt-4 w-100 flex flex-1 items-center ">
                            <button class="btn btn-secondary" v-if="showSubmitBtn">ذخیره اطلاعات</button>
                            <router-link v-if="this.$route.params.id" style="display: contents;" class="nav-link" :to="{name: 'organizationForeigners.requests' }">
                                <button class="btn btn-primary mx-2">
                                    لیست درخواست ها 
                                </button>
                            </router-link>
                        </div>
                    </form>

                </div>
            </div>
        </div>
    </div>
</template>

<script>

import moment from 'moment-jalaali';
export default {
    
    name: 'CreateOrUpdate',
    data() {
        return {
            name: "",
            lastName: "",
            dialog: false,
            gendersId: 0,
            domainId: [],
            pan:'',
            documnentsList: [],
            genders: [
                {
                    "value": 1,
                    "title": "مرد"
                },
                {
                    "value": 2,
                    "title": "زن"
                }
            ],
            maritalStatuses: [
                {
                    "value": 1,
                    "title": "مجرد"
                },
                {
                    "value": 2,
                    "title": "متاهل"
                }
            ],
            maritalStatusesId: 0,
            motherName: "",
            fatherName: "",
            birthPlaceCountriesId: 0,
            birthPlaceCountries: [],
            nationalitiesId: 0,
            nationalities: [],
            identificationDocumentTypes: [],
            identificationDocumentTypesId: 0,
            birthDate: "",
            description: "",
            showLoading: false,
            today: moment().format('YYYY-MM-DD'),
            identificationDocumentId:"",
            identificationNumber: "",
            identificationIssueDate: "",
            identificationExpirationDate: "",
            identificationPhotos:[],
            imagePass: '',
            ancestorName: "",
            cityOfBirth: "",
            showSubmitBtn: true,
            showSubmitPay: false,
            mobileNumber :"",
            referenceNumber:"",
            trackingCode:"",
            image: '',
            photoBase64:"",

        }
    },
    methods: {
        downloadFile(e,photo){
            e.preventDefault();
            if(photo.file && typeof(photo.file)== "string"){
                 this.downloadBase64File(e , photo.file , "")
            }
            else if( typeof(photo)== "string" && photo.includes("base64")){
                this.downloadBase64File(e , photo , "")
            }else if(typeof(photo)== "string"){
                  this.$api.post('Organizations/Fida/Person/GetPhoto',{photoId:photo ,  "authorizationToken": localStorage.getItem('agc-token'), }).then(({data}) => {
                    let a = window.document.createElement('a');
                    a.setAttribute('href',"data:image/png;base64," +  data.result.photoBase64);
                    a.setAttribute('download',"image.png");
                    window.document.body.appendChild(a);
                    a.click();
                    window.document.body.removeChild(a);
                });
            }
        },
        downloadBase64File(e , localimage , base64Image){
            e.preventDefault();
            let a = window.document.createElement('a');
            a.setAttribute('href',localimage || "data:image/png;base64," +  base64Image);
            a.setAttribute('download',"image.png");
            window.document.body.appendChild(a);
            a.click();
            window.document.body.removeChild(a);
        },
        async getPersonData(identificationDocumentTypes){
            try {
                this.showLoading = true
                const body = {
                    "personId": this.$route.params.id,
                }
                this.$api.post('Organizations/Fida/Person/Get', body).then(({ data }) => {
                    if (data.status) {
                        this.showLoading = false;
                        this.pan = data.result.cards? data.result.cards.cardNumber :"",
                        this.referenceNumber=data.result.referenceNumber || "",
                        this.trackingCode=data.result.trackingCode || "",
                        this.name = data.result.firstName || "-";
                        this.lastName = data.result.lastName || "-";
                        this.motherName = data.result.motherName || "-";
                        this.fatherName = data.result.fatherName || "-";
                        this.ancestorName = data.result.ancestorName || "-";
                        this.cityOfBirth = data.result.cityOfBirth || "-";
                        this.description = data.result.description || "-";
                        this.mobileNumber = data.result.mobileNumber || "";
                        this.photoBase64 = data.result.photoBase64,
                        this.gendersId = data.result.genderId;
                        this.maritalStatusesId = data.result.maritalStatusId;
                        this.birthPlaceCountriesId = data.result.birthPlaceCountryId;
                        this.nationalitiesId = data.result.nationalityId;
                        this.identificationDocumentTypesId = 6;
                        this.birthDate = data.result.birthDate;
                        data.result.documents.forEach(element => {
                            if(element && element.identificationDocumentTypeId == 6) {
                                this.identificationDocumentId = element.id,
                                this.identificationNumber= element.documentNumber,
                                this.identificationIssueDate= element.issueDate,
                                this.identificationExpirationDate= element.expirationDate,
                                this.identificationPhotos= element.photos
                            }
                            else if(element){
                                this.domainId.push(element.identificationDocumentTypeId),
                                this.documnentsList.push({
                                ...element , 
                                number :element.documentNumber,
                                title : identificationDocumentTypes.find((item)=> item.value === element.identificationDocumentTypeId ).title,
                             })
                            }
                        });
                    }
                }).catch(() => {
                    this.$swal({
                        title: 'ناموفق',
                        icon: 'error',
                        text: ' اطلاعات این کاربر یافت نشد ,لذا مجدد اقدام کنید!'
                    })
                })
            }
            catch (error) {
                this.showLoading = false
            }
        },
        async getData() {
            this.showLoading = true;
            this.$api.get('Organizations/Fida/LookUp/GetCountries').then(({ data }) => {
                this.showLoading = false;
                if (data.status) {
                    this.birthPlaceCountries = data.result;
                    this.nationalities = data.result;
                    this.getBaseData()
                }
            });
        },
         async getBaseData() {
            this.showLoading = true;
            this.$api.get('Organizations/Fida/LookUp/GetIdentificationDocumentTypeIds').then(({ data }) => {
                this.showLoading = false;
                if (data.status) {
                    this.identificationDocumentTypes = data.result.filter(item=> item.value !==6);
                    if(this.$route.params.id){
                        this.showLoading = true;
                        this.getPersonData(data.result)
                    }
                }
            });
        },
        async toBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        async setFileData(e) {
           var file = event.target.files[0];

            if (file.size > 100000) {
                this.$swal({
                    title: 'خطا',
                    icon: 'error',
                    text: 'حجم عکس نمی تواند بیشتر از 100 کیلوبایت باشد'
                });
            } else {
                const finalFile = await this.toBase64(file);
                this.image = finalFile;
                document.getElementById('file').setAttribute('placeholder', file.name);
            }
        },
        addrow: function (docIndex) {
            var elem = document.createElement('tr');
            this.documnentsList[docIndex].photos.push({
                file: {}
            });
        },
        addrowPassword:  function(){
             var elem = document.createElement('tr');
             this.identificationPhotos.push({
                file: {}
            });
        },
        copyToClipBoard(value){
            if (navigator.clipboard){
                navigator.clipboard.writeText(value).then(
                    function(){
                        alert("کپی شد"); // success 
                    })
                .catch(
                    function() {
                        alert("err"); // error
                });
            } 
        },
        removeelementPassWord: function(index){
            this.identificationPhotos.splice(index, 1);
        },
        removeelement: function (index ,docIndex) {
           this.documnentsList[docIndex].photos.splice(index, 1);
        },
        async setfilename(event, id , index ,docIndex) {
            var file = event.target.files[0];
            var img = new Image();
            img.src =  window.URL.createObjectURL( file );
            const vm = this
            img.onload =async function() {
                file.width =await this.naturalWidth
                file.height = await this.naturalHeight
                if(file.width> 800 || file.height > 800){
                 vm.$swal({
                     title: 'خطا',
                     icon: 'error',
                     text: 'رزولوشن عکس نمی تواند از 800 پیکسل بیشتر باشد.'
                 });   
                }
                if(file.width< 100 || file.height < 100){
                 vm.$swal({
                     title: 'خطا',
                     icon: 'error',
                     text: 'رزولوشن عکس نمی تواند از 100 پیکسل کمتر باشد.'
                 });   
                }
            };
            if (file.size > 1000000) {
                this.$swal({
                    title: 'خطا',
                    icon: 'error',
                    text: 'حجم عکس نمی تواند بیشتر از 1 مگابایت باشد'
                });
            } else {
                document.getElementById(id + index).setAttribute('placeholder', event.target.files[0].name);
                if(id.includes("passport")){
                    this.identificationPhotos = [
                        ...this.identificationPhotos.slice(0, index),
                        {
                            file: await this.toBase64(file) 
                        },
                        ...this.identificationPhotos.slice(index +1 ),
                    ]
                }
                else{
                    this.documnentsList = [
                        ...this.documnentsList.slice(0, docIndex),
                        {
                            ...this.documnentsList[docIndex],
                            photos : [
                                ...this.documnentsList[docIndex].photos.slice(0, index),
                                {
                                    file: await this.toBase64(file) 
                                },
                                ...this.documnentsList[docIndex].photos.slice(index +1),
                            ]
                        },
                        ...this.documnentsList.slice( docIndex + 1),
                    ]

                }
            }
        },

        updatephotosAndDocumnets(modal){
            const postedData ={
                "authorizationToken": localStorage.getItem('agc-token'),
                "personId" :this.$route.params.id,
                "identificationDocumentTypeId": 6,
                "id": this.identificationDocumentId || 0,
                "identificationNumber": this.identificationNumber,
                "identificationIssueDate": this.identificationIssueDate,
                "identificationExpirationDate": this.identificationExpirationDate ,
                "identificationPhotos": this.identificationPhotos.map(item => {
                    if(typeof item == "object") return item.file
                    return item
                }),
            } 
            this.updateDocumnets(modal)
            this.$api.post('Organizations/Fida/Person/Document/AddOrUpdate', postedData).then()
            .catch(() => {
                modal({
                    title: 'ناموفق',
                    icon: 'error',
                    text: ' اطلاعات پاسپورت ثبت نشد ,لذا مجدد اقدام کنید!'
                }).then(() => {
                    this.showLoading = false;
                });
            })
        },
        updateDocumnets(modal){
            const baseData = {
                "authorizationToken": localStorage.getItem('agc-token'),
                "personId" :this.$route.params.id,
            }
            this.documnentsList.map(item =>{
                let postedData ={...baseData,
                id:item.id ?item.id:0,
                identificationDocumentTypeId: item.identificationDocumentTypeId,
                identificationNumber: item.number,
                identificationIssueDate: item.issueDate,
                identificationExpirationDate: item.expirationDate,
                identificationPhotos: item.photos.map(item =>  {
                if(typeof item == "object") return item.file
                    return item
                    })
                }
                this.$api.post('Organizations/Fida/Person/Document/AddOrUpdate', postedData).then()
                .catch(() => {
                    modal({
                        title: 'ناموفق',
                        icon: 'error',
                        text:  "اطلاعات " + item.title  + " ثبت نشد ,لذا مجدد اقدام کنید!"
                    }).then(() => {
                        this.showLoading = false;
                    });
                })
            })
        },
        initiateEmpyState(){
            this.pan = "",
            this.name = "",
            this.lastName ="",
            this.motherName =  "",
            this.mobileNumber =  "",
            this.fatherName =  "",
            this.ancestorName = "",
            this.cityOfBirth = "",
            this.description = "",
            this.gendersId = "",
            this.maritalStatusesId = "",
            this.birthPlaceCountriesId = "",
            this.nationalitiesId = "",
            this.identificationDocumentTypesId = "",
            this.identificationNumber= "",
            this.identificationIssueDate= "",
            this.identificationExpirationDate= "",
            this.identificationPhotos=[],
            this.birthDate = "",
            this.referenceNumber="",
            this.trackingCode="",
            this.photoBase64 = "",
            this.photo = ""
        },
        submit() {
            if(!this.image && !this.photoBase64){
                this.$swal({
                    icon: 'warning',
                    title: 'توجه !',
                    text: 'لطفا تصویر پرسنلی را انتخاب نمایید.'
                })
            }else{
                this.$dialog
                    .confirm('آیا از درخواست خود اطمینان دارید ؟ ')
                    .then((dialog) => {
                        this.showLoading = true;
                        this.showSubmitBtn = false;
                        let postedData = {
                            "authorizationToken": localStorage.getItem('agc-token'),
                            "person": {
                                "id" : this.$route.params.id? this.$route.params.id : "",
                                "cityOfBirth": this.cityOfBirth,
                                "ancestorName": this.ancestorName,
                                "firstName": this.name,
                                "lastName": this.lastName,
                                "genderId": this.gendersId,
                                "fatherName": this.fatherName,
                                "motherName": this.motherName,
                                "birthDate": this.birthDate,
                                "mobileNumber": this.mobileNumber.replace('-', ''),
                                "birthPlaceCountryId": this.birthPlaceCountriesId,
                                "birthPlaceCountry":!this.birthPlaceCountriesId ? "" : this.birthPlaceCountries.find(item => item.value === this.birthPlaceCountriesId).title,
                                "nationalityId": this.nationalitiesId,
                                "nationality": !this.nationalitiesId ? "" : this.nationalities.find(item => item.value === this.nationalitiesId).title,
                                "maritalStatusId": this.maritalStatusesId,
                                "description": this.description,
                                "cardNumber":this.pan? this.pan.replace(/-/g,'') : "",
                            "photo": this.image || "data:image/jpeg;base64," +this.photoBase64,
                            }
                        };
                        if(!this.$route.params.id){
                            postedData = {...postedData,
                                "person":{
                                    ...postedData.person,
                                    "identificationDocumentTypeId": 6,
                                    "identificationNumber": this.identificationNumber,
                                    "identificationIssueDate": this.identificationIssueDate,
                                    "identificationExpirationDate": this.identificationExpirationDate,
                                    "identificationPhotos": this.identificationPhotos.map(item => {
                                        if(typeof item == "object") return item.file
                                        return item
                                    }),
                                    "identificationDocument":  this.documnentsList.map(item => ({
                                            id:item.id,
                                            identificationDocumentTypeId: item.identificationDocumentTypeId,
                                            number: item.number,
                                            issueDate: item.issueDate,
                                            expirationDate: item.expirationDate,
                                            photos: item.photos.map(item =>  {
                                            if(typeof item == "object") return item.file
                                            return item
                                        })
                                    }))
                                }
                            }
                        }else{
                            this.updatephotosAndDocumnets(this.$swal);
                        }
                        this.$api.post( this.$route.params.id ? "Organizations/Fida/Person/Update" : "Organizations/Fida/Register", postedData).then(({ data }) => {
                            if (data.status) {
                                this.$swal({
                                    title: 'تبریک',
                                    icon: 'success',
                                    text:this.$route.params.id? "کاربر با موفقیت ویرایش شد." : 'کاربر جدید با موفقیت ایجاد شد'
                                }).then(() => {
                                    if(!this.$route.params.id){
                                        this.$router.push({ name: 'organizationForeigners.requests' });
                                    }
                                });
                            }
                        }).catch(() => {
                            this.$swal({
                                title: 'ناموفق',
                                icon: 'error',
                                text: ' اطلاعات این کاربر ثبت نشد ,لذا مجدد اقدام کنید!'
                            }).then(() => {
                                this.showLoading = false;
                                if(!this.$route.params.id){
                                        this.$router.push({ name: 'organizationForeigners.requests' });
                                }
                            });
                        }).finally(() => {
                            this.showLoading = false;
                            this.showSubmitBtn = true;
                            if (dialog) { dialog.close() }
                        })
                    })
            }
        },
        showSubmitPAY() {
            this.showSubmitPay = !this.showSubmitPay
        }
    },
    watch: {
        "$route.params.id":{
            handler: function(value) {
                if(!value){
                    this.initiateEmpyState()
                }
            },
            deep: true,
            immediate: true,
        },
        domainId(value){
            this.documnentsList= value.map(documnet =>{
                let searchItem = this.documnentsList.find(i => i.identificationDocumentTypeId === documnet)
                if(searchItem) return searchItem;
                else{ 
                    return {     
                        title : this.identificationDocumentTypes.find((item)=> item.value === documnet ).title,   
                        identificationDocumentTypeId: documnet,
                        number: "",
                        issueDate: "",
                        expirationDate: "",
                        photos: []
                    }
                }}
            )
        }
    },
    created() {
        this.getData();
    }
}
</script>
